import React from 'react';
import { Gap, Icon, Text, Link } from '@common/components';
import { buildDialogUrl } from '@common/services';
import { getActionTypeTitle } from '@approvals/services/approvals-service';
import { ActionTypeTitlesType } from '@approvals/graphql';

type Props = {
  unitId: string;
  actionTypeKey: ActionTypeTitlesType;
  organizationBusinessName: string;
};

export const ApprovalsEditDrawerTrigger = ({
  unitId,
  actionTypeKey,
  organizationBusinessName,
}: Props) => {
  const actionTypeTitle = getActionTypeTitle(actionTypeKey);
  const approvalsEditDrawerUrl = buildDialogUrl('approvals-edit-drawer', {
    props: {
      unitId,
      actionTypeKey,
      facilityName: organizationBusinessName,
    },
  });

  return (
    <Link to={approvalsEditDrawerUrl}>
      <Gap>
        <Text bold color="elm">
          {actionTypeTitle}
        </Text>
        <Icon icon="pen" />
      </Gap>
    </Link>
  );
};
